import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.#footerAccordions()
    this.#registerOpener()
    this.#setLocale()
    this.#googleTagManager()
    this.#switchBackgroundHeader()
  }

  #googleTagManager() {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageView',
        pagePath: document.location.pathname + document.location.search
      })
    }
  }

  #setLocale() {
    I18n.locale = document.documentElement.lang
  }

  #registerOpener() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('register')) {
      setTimeout(() => {
        $('[data-register-form] button').click()
      }, 100)
    }
  }

  #footerAccordions() {
    document.querySelectorAll('[data-accordeon]').forEach(element => {
      element.addEventListener('click', event => {
        event.currentTarget.parentElement.classList.toggle('is-close')
      })
    })
  }

  #switchBackgroundHeader() {
    const html = document.documentElement
    const target = document.querySelector("[data-target-switch-header]")
    const trigger = document.querySelector("[data-trigger-switch-header]")
    if (!trigger) return

    const offset = trigger.offsetHeight + target.offsetHeight * 2

    const update = (entries) => {
      const entry = entries[0]
      if (!entry.isIntersecting) {
        html.setAttribute("data-switch-header", "has-background")
      } else {
        html.removeAttribute("data-switch-header")
      }
    }

    const observer = new IntersectionObserver(update, {
      rootMargin: `-${offset}px 0px 0px 0px`
    })

    observer.observe(trigger)
  }
}